module.exports = "<svg viewBox=\"0 0 30 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M29 0H30V6H29V3.5H0V2.5H29V0Z\"></path></svg>"